/* eslint-disable react/prop-types */
import ConfirmationModal from 'components/custom/modal/ConfirmationModal';
import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

const icons = {
  success: 'icon-park-outline:check-one',
  warning: 'fluent:warning-32-filled',
  info: 'heroicons-outline:information-circle',
  danger: 'fluent:warning-32-filled'
};

export const ModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({});
  const [showModal, setShowModal] = useState(false);

  const showConfirmation = props => {
    setModalProps(props);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  const handleConfirm = () => {
    if (modalProps.onConfirm) {
      modalProps.onConfirm();
    }
    setShowModal(false);
  };

  return (
    <ModalContext.Provider value={{ showConfirmation }}>
      {children}

      {modalProps?.customContent || (
        <ConfirmationModal
          show={showModal}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
          icon={icons[modalProps.severity]}
          message={modalProps.message}
          confirmBtn={modalProps.confirmBtn}
          severity={modalProps.severity}
          showFooter={modalProps.showFooter}
        />
      )}
    </ModalContext.Provider>
  );
};
